export default "__VITE_PUBLIC_ASSET__15012fc5__"